module.exports = __webpack_public_path__ + "b58cac0162acd86203d2670f928fe15b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-baseball-glove.png
// module id = 2810
// module chunks = 0